import { createClient, Session, User } from "@supabase/supabase-js"
import { alerts } from "@utils/alerts"
import { proxy, ref, useSnapshot } from "valtio"
import { AUTH_MODALS, AuthModalName } from "./auth-modals"
import { getFlyingCarpetStore, useFlyingCarpet } from "@features/flying-carpet/useFlyingCarpet"

let didSignUp = false

function createAuthStore() {
  const client = createClient(
    "https://inesizxphuyprsbsibhl.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImluZXNpenhwaHV5cHJzYnNpYmhsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzNTEzNTIsImV4cCI6MjA1NTkyNzM1Mn0.nZxbadjXFVTncZGyYFM2ueXgqgkrHtD_5jbKW239D80",
    {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
      },
    },
  )
  const store = proxy({
    api: ref(client),
    showingModal: null as Modal<AuthModalName> | null,
    user: undefined as undefined | User,
    session: undefined as undefined | Session,
    get loggedIn(): boolean {
      return !!store.session?.access_token
    },
    openModal<T extends AuthModalName>(modal: T, props: Parameters<(typeof AUTH_MODALS)[T]>[0]) {
      store.showingModal = { name: modal, props }
    },
    closeModal() {
      store.showingModal = null
    },
  })

  if (env.client) {
    store.api.auth.onAuthStateChange((event, session) => {
      store.user = session?.user
      store.session = session!

      if (event === "PASSWORD_RECOVERY") {
        store.openModal("choose-new-password", {})
      } else if (event === "SIGNED_IN") {
        if (didSignUp) {
          getFlyingCarpetStore().launch("account")
          didSignUp = false
        }
      }
    })

    if (document.location.hash.includes("error_code=otp_expired")) {
      alerts.displayAlert({
        title: "Link Expired",
        description: "The confirmation link that you have clicked has expired! Please try logging in again.",
      })
      document.location.hash = ""
    } else if (document.location.hash.includes("type=signup")) {
      didSignUp = true
    }
  }

  // @ts-ignore
  if (env.client) window.auth = store

  return store
}

type Modal<T extends AuthModalName> = {
  name: T
  props: Parameters<(typeof AUTH_MODALS)[T]>[0]
}
type AuthStore = ReturnType<typeof createAuthStore>

let authStore: AuthStore | undefined

export function useAuth() {
  if (!authStore) {
    authStore = createAuthStore()
  }

  return useSnapshot(authStore)
}
